
import { motion } from "framer-motion"
import { Controller } from "react-hook-form"
import { Input } from "../UI/input"
import { Eye, EyeOff } from "lucide-react"

interface FormFieldProps {
  name: string
  label: string
  placeholder: string
  control: any
  errors: any
  type?: string
  showPassword?: boolean
  onTogglePassword?: () => void
  delay?: number
}

export const FormField = ({
  name,
  label,
  placeholder,
  control,
  errors,
  type = "text",
  showPassword,
  onTogglePassword,
  delay = 0,
}: FormFieldProps) => {
  const isPasswordField = type === "password" || (type === "text" && onTogglePassword)

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay, duration: 0.5 }}
      className="space-y-2"
    >
      <label className="block text-sm font-semibold text-gray-700 mb-2">{label}</label>

      <div className="relative">
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              type={isPasswordField ? (showPassword ? "text" : "password") : type}
              placeholder={placeholder}
              className={`w-full h-12 px-4 pr-12 text-base border-2 rounded-xl transition-all duration-200 focus:border-sky-500 focus:ring-4 focus:ring-sky-100 ${
                errors[name]
                  ? "border-red-300 bg-red-50 focus:border-red-500 focus:ring-red-100"
                  : "border-gray-200 bg-white hover:border-gray-300"
              }`}
            />
          )}
        />

        {isPasswordField && onTogglePassword && (
          <button
            type="button"
            onClick={onTogglePassword}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
      </div>

      {errors[name] && (
        <motion.p
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-sm text-red-500 font-medium"
        >
          {errors[name].message}
        </motion.p>
      )}
    </motion.div>
  )
}
